$(document).on('click', "a[href='#']", function (e) {
  e.preventDefault()
  document.querySelector('#scroll_product').scrollIntoView({
    behavior: 'smooth',
  })
})

$(document).on('click', "a[href='#reviews']", function (e) {
  e.preventDefault()
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth',
  })
})

$(document).on('click', '.custom_button', function (e) {
  var video = jQuery(this).parents('.video_wrapper_custom').find('video')
  if (jQuery(this).hasClass('active')) {
    jQuery(this).parents('.video_wrapper_custom').removeClass('video-active')
    jQuery(this).removeClass('active')
    video.trigger('pause')
  } else {
    video.trigger('play')
    jQuery(this).parents('.video_wrapper_custom').addClass('video-active')
    jQuery(this).addClass('active')
  }
})

$(document).on('click', '.video_wrapper_custom.video-active', function (e) {
  var video = jQuery(this).find('video')
  var videoElement = video.get(0)
  if (videoElement.paused) {
    jQuery(this).removeClass('video-active')
    jQuery(this).find('.custom_button').removeClass('active')
    video.trigger('pause')
  } else {
  }
})

$(document).on(
  'click',
  '.question_product:not(.scroll_reviews,.scroll_how_it_works,.scroll_compare),.faq_question',
  function (e) {
    if (jQuery(this).hasClass('active')) {
      jQuery(this).toggleClass('active')
      jQuery(this).next().slideToggle()
    } else {
      jQuery('.question_product,.faq_question').removeClass('active')
      jQuery('.question_product,.faq_question').next().slideUp()
      jQuery(this).toggleClass('active')
      jQuery(this).next().slideToggle()
    }
  }
)

$(document).on('click', '.question_product.scroll_reviews', function (e) {
  e.preventDefault()
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth',
  })
})
$(document).on('click', '.question_product.scroll_how_it_works', function (e) {
  e.preventDefault()
  document.querySelector('#how_it_works').scrollIntoView({
    behavior: 'smooth',
  })
})

$(document).on('click', '.question_product.scroll_compare', function (e) {
  e.preventDefault()
  document.querySelector('#compare').scrollIntoView({
    behavior: 'smooth',
  })
})

$(window).on('load', function () {
  setInterval(function () {
    var html = $('.main_page_product .product-form_order-countdown').html()
    $('body .landing_product_slider_item .product-form_order-countdown').html(html).css('visibility', 'visible')
  }, 1000)
})
